import React, { useEffect, useState } from "react";
import logo from "../assets/logo.png";


function PriceTableHeader(props) {
    const {title} = props;
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const formatTime = (date) => {
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const seconds = date.getSeconds().toString().padStart(2, "0");
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const dayOfWeek = ["Chủ nhật", "Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"][date.getDay()];

        return `${hours}:${minutes}:${seconds} --- ${dayOfWeek}, ${day}/${month}/${year}`;
    };

    return (
        <div className="price-table-header">
            <div className="header-logo">
                <img src={logo} alt="logo" />
            </div>
            <div>
                <div className="header-right">
                    <span className="current-time">{formatTime(currentTime)}</span>
                </div>
                <div className="header-center">
                    <h2 className="table-title">{title}</h2>
                </div>
            </div>
        </div>
    );
}

export default PriceTableHeader;
